import { render, staticRenderFns } from "./BusinessApplicationMaterialPreview.vue?vue&type=template&id=625cd8ca&"
import script from "./BusinessApplicationMaterialPreview.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationMaterialPreview.vue?vue&type=script&lang=js&"
import style0 from "./BusinessApplicationMaterialPreview.vue?vue&type=style&index=0&id=625cd8ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports